module.exports = __webpack_public_path__ + "static/hand-45ea4f41b1d9038afb442eb0eb0a05ea.png";